import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../bootstrap';
import $ from 'jquery';
import 'jquery-colorbox';

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', () => {
  $('.js-youtube').colorbox({
    iframe: true,
    innerWidth: 640,
    innerHeight: 360,
    maxWidth: '90%',
    maxHeight: '51%',
  });
});

// 最近チェックした商品のスライダー
import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Pagination]);

const swiper = new Swiper('.slide-items__container', {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 20,
  loop: true,
  loopFillGroupWithBlank: true,
  pagination: {
    el: '.slide-items__pagination',
    clickable: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 30,
    },
  },
});